module.exports = __webpack_public_path__ + "static/img/8.4601897.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/6/1/sp/8.png
// module id = Ai3x
// module chunks = 0